import React, { useState, useEffect } from 'react';

interface Props {
  onOpenPrivacyModal?: () => void;
}

const Footer: React.FC<Props> = ({ onOpenPrivacyModal }) => {
  const [contactInfo, setContactInfo] = useState({ phone: '', email: '' });

  useEffect(() => {
    // Decode obfuscated contact information
    const phoneEncoded = 'KzQ2NzA5NDk5NDk2'; // +46709499496
    const emailEncoded = 'aW5mb0B1dHZlY2tsYXJlZGlyZWt0LnNl'; // info@utvecklaredirekt.se

    try {
      const phone = atob(phoneEncoded);
      const email = atob(emailEncoded);
      setContactInfo({ phone, email });
    } catch (error) {
      console.error('Failed to decode contact information');
    }
  }, []);
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-4 py-3">

        {/* Main Footer Content */}
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">

          {/* Logo Section */}
          <div className="flex items-center space-x-3">
            <img
              src="/images/utvecklaredirekt_logo.png"
              alt="Utvecklare Direkt"
              className="h-8 w-auto"
            />
            <div>
              <p className="text-gray-400 text-sm">Kapris Sweden AB (556954-3746)</p>
              <p className="text-gray-500 text-xs">© 2025 Utvecklare Direkt. Stödjer ukrainsk teknisk talang.</p>
            </div>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col lg:flex-row lg:items-center gap-3 text-sm">
            {contactInfo.phone && (
              <a
                href={`tel:${contactInfo.phone}`}
                className="text-primary-400 hover:text-primary-300 flex items-center gap-1"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                {contactInfo.phone.replace(/(\+46)(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5')}
              </a>
            )}
            {contactInfo.email && (
              <a
                href={`mailto:${contactInfo.email}`}
                className="text-primary-400 hover:text-primary-300 flex items-center gap-1"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                {contactInfo.email}
              </a>
            )}
            <button
              onClick={onOpenPrivacyModal}
              className="text-gray-400 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 rounded bg-transparent border-none p-0 cursor-pointer text-sm"
            >
              Integritetspolicy
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 